import bus from "eventbusjs";

export const ErrorService = (text, args) => {
  bus.dispatch("notification", this, {
    text,
    type: "critical",
    ...args,
  });
};
